<template>
  <div class="merchants">
    <h1>商户管理</h1>
    <div class="sub">平台注册用户档案：注册资料、绑定账号、行业分布、套餐与找客点余额</div>

    <!-- 统计条 -->
    <div class="stat-row">
      <div class="stat">
        <div class="stat-v">{{ list.length }}</div>
        <div class="stat-l">商户总数</div>
      </div>
      <div class="stat">
        <div class="stat-v">{{ boundCount }}</div>
        <div class="stat-l">已绑抖音号</div>
      </div>
      <div class="stat">
        <div class="stat-v">{{ loggedInTotal }}</div>
        <div class="stat-l">已登录账号</div>
      </div>
      <div class="stat">
        <div class="stat-v">{{ industryCount }}</div>
        <div class="stat-l">已选行业</div>
      </div>
      <div class="stat">
        <div class="stat-v">{{ pointsTotal }}</div>
        <div class="stat-l">找客点合计</div>
      </div>
    </div>

    <!-- 工具条 -->
    <el-card>
      <template #header>
        <div class="card-header">
          <span>商户列表</span>
          <div>
            <el-input
              v-model="kw"
              placeholder="搜索手机号 / 昵称"
              clearable
              size="small"
              style="width: 220px; margin-right: 8px"
            >
              <template #prefix><span>🔍</span></template>
            </el-input>
            <el-button size="small" :loading="loading" @click="load">🔄 刷新</el-button>
          </div>
        </div>
      </template>

      <el-table :data="filtered" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="phone" label="手机号" width="130" />
        <el-table-column prop="nickname" label="昵称" width="120" />
        <el-table-column label="角色" width="80">
          <template #default="scope">
            <el-tag size="small" :type="scope.row.role === 'admin' ? 'danger' : 'info'">
              {{ scope.row.role === 'admin' ? '管理员' : '商户' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template #default="scope">
            <el-tag size="small" :type="scope.row.status === 'active' ? 'success' : 'danger'">
              {{ scope.row.status === 'active' ? '正常' : '已停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="注册天数" width="90">
          <template #default="scope">
            <span :class="{ warn: daysOf(scope.row.created_at) > 60 }">{{ daysOf(scope.row.created_at) }} 天</span>
          </template>
        </el-table-column>
        <el-table-column label="抖音号" width="110">
          <template #default="scope">
            <el-tag size="small" :type="scope.row.account_count > 0 ? 'success' : 'info'">
              {{ scope.row.account_count }} 个{{ scope.row.logged_in_count > 0 ? `（${scope.row.logged_in_count} 在线）` : '' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="行业" min-width="150">
          <template #default="scope">
            <template v-if="scope.row.industries && scope.row.industries.length">
              <el-tag v-for="n in scope.row.industries" :key="n" size="small" type="success" style="margin-right:4px">{{ n }}</el-tag>
            </template>
            <el-tag v-else size="small" type="info">未设置</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="套餐到期" width="105">
          <template #default="scope">
            <span :class="{ warn: isExpired(scope.row) }">{{ scope.row.plan_expire || '未开通' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="找客点" width="90">
          <template #default="scope">
            <b class="pts">{{ scope.row.balance_points }}</b>
          </template>
        </el-table-column>
        <el-table-column label="雷达" width="70">
          <template #default="scope">
            <el-tag size="small" :type="scope.row.radar_on ? 'success' : 'info'">
              {{ scope.row.radar_on ? '开' : '关' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="160">
          <template #default="scope">{{ scope.row.created_at }}</template>
        </el-table-column>
        <el-table-column label="操作" width="250" fixed="right">
          <template #default="scope">
            <el-button size="small" type="primary" text @click="showDetail(scope.row)">详情</el-button>
            <el-button size="small" type="warning" text :loading="pwdLoadingId === scope.row.id"
              @click="askResetPwd(scope.row)">重置密码</el-button>
            <el-button v-if="scope.row.status === 'active'" size="small" type="danger" text
              @click="askDisable(scope.row)">停用</el-button>
            <el-button v-else size="small" type="success" text
              @click="enableRow(scope.row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 详情抽屉 -->
    <el-drawer v-model="detailVisible" :title="detail.nickname || detail.phone" size="460px">
      <template v-if="detail.id">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="商户 ID">{{ detail.id }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detail.phone }}</el-descriptions-item>
          <el-descriptions-item label="昵称">{{ detail.nickname || '—' }}</el-descriptions-item>
          <el-descriptions-item label="角色">{{ detail.role === 'admin' ? '管理员' : '商户' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag size="small" :type="detail.status === 'active' ? 'success' : 'danger'">
              {{ detail.status === 'active' ? '正常' : '已停用' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ detail.created_at }}</el-descriptions-item>
          <el-descriptions-item label="最后活跃">{{ detail.updated_at || '—' }}</el-descriptions-item>
          <el-descriptions-item label="套餐到期">{{ detail.plan_expire || '未开通' }}</el-descriptions-item>
          <el-descriptions-item label="找客点余额">{{ detail.balance_points }}</el-descriptions-item>
          <el-descriptions-item label="邀请码">{{ detail.invite_code || '—' }}</el-descriptions-item>
          <el-descriptions-item label="邀请人 ID">{{ detail.inviter_id || '无' }}</el-descriptions-item>
          <el-descriptions-item label="雷达采集">{{ detail.radar_on ? '已开启' : '未开启' }}</el-descriptions-item>
        </el-descriptions>

        <h4 class="sec">🎵 绑定的账号（{{ detail.account_count }} 个，{{ detail.logged_in_count }} 个在线）</h4>
        <div v-if="detailAccs.length === 0" class="empty-tip">该商户尚未绑定任何平台账号</div>
        <div v-else class="acc-list">
          <div v-for="a in detailAccs" :key="a.id" class="acc-item">
            <div class="acc-ico">{{ a.platform === 'kuaishou' ? '🎬' : '🎵' }}</div>
            <div class="acc-body">
              <div class="acc-name">
                {{ a.nickname || a.username }}
                <el-tag size="small" :type="a.is_logged_in ? 'success' : 'info'">
                  {{ a.is_logged_in ? '已登录' : '未登录' }}
                </el-tag>
              </div>
              <div class="acc-meta">
                {{ a.platform === 'kuaishou' ? '快手' : '抖音' }} · {{ a.username }}
                <span v-if="a.industry"> · 行业：{{ a.industry }}</span>
                <span v-else class="warn"> · 未设置行业</span>
              </div>
              <div class="acc-meta">最近登录：{{ a.last_login || '从未' }}</div>
            </div>
          </div>
        </div>

        <h4 class="sec">🎯 行业分布</h4>
        <div v-if="detail.industries && detail.industries.length">
          <el-tag v-for="n in detail.industries" :key="n" size="small" type="success" style="margin: 0 4px 6px 0">{{ n }}</el-tag>
        </div>
        <div v-else class="empty-tip">该商户尚未选择行业</div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Merchants',
  data() {
    return {
      list: [],
      kw: '',
      loading: false,
      detailVisible: false,
      detail: {},
      detailAccs: [],
      // 🛡 2026-09-06 批次 17：管理员操作（重置密码 / 停用启用）
      pwdLoadingId: 0,
      pwdTarget: null
    }
  },
  computed: {
    filtered() {
      const kw = (this.kw || '').trim().toLowerCase()
      if (!kw) return this.list
      return this.list.filter(u =>
        (u.phone || '').includes(kw) ||
        (u.nickname || '').toLowerCase().includes(kw)
      )
    },
    boundCount() { return this.list.filter(u => u.account_count > 0).length },
    loggedInTotal() { return this.list.reduce((s, u) => s + (u.logged_in_count || 0), 0) },
    industryCount() { return this.list.filter(u => u.industries && u.industries.length > 0).length },
    pointsTotal() { return this.list.reduce((s, u) => s + (u.balance_points || 0), 0) }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        this.list = await api.get('/users')
      } catch (e) {
        this.$message.error('加载商户档案失败：' + (e.detail || e.message || ''))
        if (e.status === 403) this.list = []
      } finally {
        this.loading = false
      }
    },
    // 🛡 重置商户密码（仅平台管理员；后端二次校验白名单，非 13800138000 返回 403）
    async askResetPwd(row) {
      if (row.role === 'admin') {
        this.$message.warning('不能重置平台管理员的密码')
        return
      }
      this.pwdTarget = row
      let value = ''
      try {
        const res = await this.$prompt(
          `请为 ${row.phone}（${row.nickname || '商户'}）设置新的登录密码，6-20 位。`,
          '🔑 重置密码',
          {
            confirmButtonText: '确认重置',
            cancelButtonText: '取消',
            inputPattern: /^.{6,20}$/,
            inputErrorMessage: '密码长度需 6-20 位',
            inputPlaceholder: '输入新密码'
          }
        )
        value = res.value
      } catch (e) {
        return   // 用户取消
      }
      this.pwdLoadingId = row.id
      try {
        const r = await api.post(`/users/${row.id}/reset-password`, { new_password: value })
        this.$alert(r.msg || '密码已重置', '✅ 重置成功', { type: 'success', confirmButtonText: '知道了' })
      } catch (e) {
        this.$message.error('重置失败：' + (e.detail || e.message || ''))
      } finally {
        this.pwdLoadingId = 0
      }
    },
    // 🛡 停用商户账号（停用后无法登录，历史数据保留）
    async askDisable(row) {
      if (row.role === 'admin') {
        this.$message.warning('不能停用平台管理员账号')
        return
      }
      try {
        await this.$confirm(
          `确定停用 ${row.phone}（${row.nickname || '商户'}）吗？\n\n停用后该商户将无法登录后台；其账号、线索与发布记录均保留，随时可恢复启用。`,
          '🚫 停用账号',
          { confirmButtonText: '确认停用', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return
      }
      await this.setStatus(row, 'disabled')
    },
    async enableRow(row) {
      await this.setStatus(row, 'active')
    },
    async setStatus(row, status) {
      try {
        const r = await api.patch(`/users/${row.id}/status`, { status })
        this.$message.success(r.msg || '已更新')
        if (this.detail && this.detail.id === row.id) this.detail.status = status
        this.load()
      } catch (e) {
        this.$message.error('操作失败：' + (e.detail || e.message || ''))
      }
    },
    async showDetail(row) {
      this.detail = row
      this.detailVisible = true
      this.detailAccs = []
      try {
        const r = await api.get('/accounts/', { params: { owner: row.id, limit: 100 } })
        this.detailAccs = Array.isArray(r) ? r : (r.accounts || [])
      } catch (e) {
        this.detailAccs = []
      }
    },
    daysOf(ts) {
      if (!ts) return 0
      const d = new Date(ts)
      if (isNaN(d.getTime())) return 0
      return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000))
    },
    isExpired(row) {
      if (!row.plan_expire) return false
      const d = new Date(row.plan_expire)
      return !isNaN(d.getTime()) && d.getTime() < Date.now()
    }
  }
}
</script>

<style scoped>
.merchants {
  padding: 20px;
}
.merchants h1 {
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 4px;
}
.sub {
  font-size: 13px;
  color: #94a3b8;
  margin-bottom: 18px;
}

/* 统计条 */
.stat-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}
.stat {
  padding: 16px 18px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(37, 99, 235, .12), rgba(16, 185, 129, .06));
  border: 1px solid rgba(56, 189, 248, .22);
}
.stat-v {
  font-size: 28px;
  font-weight: 900;
  color: #fff;
  line-height: 1.2;
}
.stat-l {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 4px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.warn {
  color: #e6a23c;
}
.pts {
  color: #38bdf8;
  font-size: 15px;
}

/* 抽屉 */
.sec {
  font-size: 14px;
  font-weight: 700;
  color: #e2e8f0;
  margin: 20px 0 10px;
}
.empty-tip {
  padding: 14px;
  border-radius: 10px;
  background: rgba(148, 163, 184, .06);
  border: 1px dashed rgba(148, 163, 184, .2);
  color: #64748b;
  font-size: 13px;
  text-align: center;
}
.acc-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.acc-item {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(148, 163, 184, .05);
  border: 1px solid rgba(148, 163, 184, .14);
}
.acc-ico {
  font-size: 26px;
  flex-shrink: 0;
  line-height: 1.2;
}
.acc-body { flex: 1; }
.acc-name {
  font-size: 15px;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.acc-meta {
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.7;
}

@media (max-width: 767px) {
  .merchants { padding: 14px; }
  .card-header { flex-direction: column; align-items: stretch; gap: 8px; }
  .card-header > div { display: flex; justify-content: flex-end; }
}
</style>
